module.exports = __webpack_public_path__ + "media/images/okra-offers/Rewards-Earn-02-9d14c52e3f75bc2f6e250d462bad2ff6.jpg";